import { render, staticRenderFns } from "./shareDeeplink.vue?vue&type=template&id=74965488"
import script from "./shareDeeplink.vue?vue&type=script&lang=js"
export * from "./shareDeeplink.vue?vue&type=script&lang=js"
import style0 from "./shareDeeplink.vue?vue&type=style&index=0&id=74965488&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports